interface BluePrintLogoProps {
  /** 'mark' = icon only, 'wordmark' = icon + text (default) */
  variant?: 'mark' | 'wordmark';
  /** Height of the mark in px (width scales proportionally). Default: 32 */
  size?: number;
  className?: string;
}

/** BluePrint ascending-layers mark, optionally with the "BluePrint" wordmark */
export default function BluePrintLogo({ variant = 'wordmark', size = 32, className }: BluePrintLogoProps) {
  const Mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="bp-logo-bg" x1="4" y1="4" x2="44" y2="44">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#4C1D95" />
        </linearGradient>
      </defs>
      {/* Background */}
      <rect x="4" y="4" width="40" height="40" rx="10" fill="url(#bp-logo-bg)" />
      {/* Layer shadows */}
      <path d="M11 35 L25 28 L39 35 L25 42 Z" fill="black" opacity="0.15" />
      <path d="M11 29 L25 22 L39 29 L25 36 Z" fill="black" opacity="0.12" />
      <path d="M11 23 L25 16 L39 23 L25 30 Z" fill="black" opacity="0.1" />
      <path d="M11 17 L25 10 L39 17 L25 24 Z" fill="black" opacity="0.08" />
      {/* Layers */}
      <path d="M10 34 L24 27 L38 34 L24 41 Z" fill="white" opacity="0.2" />
      <path d="M10 28 L24 21 L38 28 L24 35 Z" fill="white" opacity="0.4" />
      <path d="M10 22 L24 15 L38 22 L24 29 Z" fill="white" opacity="0.6" />
      <path d="M10 16 L24 9 L38 16 L24 23 Z" fill="white" opacity="0.9" />
      {/* 3D side faces */}
      <path d="M10 16 L10 22 L24 29 L24 23 Z" fill="white" opacity="0.1" />
      <path d="M10 22 L10 28 L24 35 L24 29 Z" fill="white" opacity="0.06" />
      {/* Accent spark */}
      <circle cx="24" cy="9" r="2.5" fill="#EC4899" />
    </svg>
  );

  if (variant === 'mark') {
    return <span className={className}>{Mark}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2.5 ${className ?? ''}`}>
      {Mark}
      <span
        style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: size * 0.5625, lineHeight: 1, letterSpacing: '-0.01em' }}
      >
        <span style={{ color: '#FAFAF9' }}>Blue</span>
        <span style={{ color: '#A78BFA' }}>Print</span>
      </span>
    </span>
  );
}
